(function () {
  'use strict';

  var iframeSelector = [
    '.shogun-video iframe[src*="youtube.com/embed/"]',
    '.shogun-video iframe[src*="youtube-nocookie.com/embed/"]',
    '.rte__video-wrapper iframe[src*="youtube.com/embed/"]',
    '.rte__video-wrapper iframe[src*="youtube-nocookie.com/embed/"]'
  ].join(',');

  function getVideoId(source) {
    try {
      var url = new URL(source, window.location.origin);
      var match = url.pathname.match(/\/embed\/([^/?]+)/);
      return match ? match[1] : '';
    } catch (error) {
      return '';
    }
  }

  function getPosterUrl(iframe, videoId) {
    var wrapper = iframe.closest('.shogun-video, .rte__video-wrapper');
    return iframe.getAttribute('data-kbd-youtube-poster') ||
      (wrapper && wrapper.getAttribute('data-kbd-youtube-poster')) ||
      'https://i.ytimg.com/vi/' + encodeURIComponent(videoId) + '/maxresdefault.jpg';
  }

  function addAutoplay(source) {
    try {
      var url = new URL(source, window.location.origin);
      url.searchParams.set('autoplay', '1');
      return url.toString();
    } catch (error) {
      return source + (source.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
    }
  }

  function enhanceIframe(iframe) {
    if (!iframe || iframe.dataset.kbdPosterProcessed === 'true') return;

    var source = iframe.getAttribute('src');
    var videoId = getVideoId(source);
    if (!source || !videoId) return;

    iframe.dataset.kbdPosterProcessed = 'true';

    var playerTemplate = iframe.cloneNode(true);
    var poster = document.createElement('button');
    var posterImage = document.createElement('img');
    var playLabel = window.theme && window.theme.strings && window.theme.strings.videoPlay;

    poster.type = 'button';
    poster.className = 'kbd-youtube-poster';
    poster.setAttribute('aria-label', playLabel || iframe.title || 'Play video');

    posterImage.className = 'kbd-youtube-poster__image';
    posterImage.src = getPosterUrl(iframe, videoId);
    posterImage.alt = '';
    posterImage.loading = 'lazy';
    posterImage.decoding = 'async';
    posterImage.addEventListener('load', function () {
      if (posterImage.naturalWidth <= 120 && posterImage.src.indexOf('/maxresdefault.jpg') !== -1) {
        posterImage.src = 'https://i.ytimg.com/vi/' + encodeURIComponent(videoId) + '/hqdefault.jpg';
      }
    });

    poster.appendChild(posterImage);
    poster.addEventListener('click', function () {
      var player = playerTemplate.cloneNode(true);
      player.src = addAutoplay(source);
      player.loading = 'eager';
      player.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      player.dataset.kbdPosterProcessed = 'true';
      poster.replaceWith(player);
    }, { once: true });

    iframe.replaceWith(poster);
  }

  function scan(root) {
    if (!root || root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches(iframeSelector)) enhanceIframe(root);
    root.querySelectorAll(iframeSelector).forEach(enhanceIframe);
  }

  function init() {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
